import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";

// Fetch all skills
export const getSkills = async () => {
  try {
    const response = await api.get(`${API_URL}/skills`);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};

// Add a new skill
export const addSkill = async (skill) => {
  try {
    const response = await api.post(`${API_URL}/skills`, skill);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};

// Update a skill
export const updateSkill = async (id, skill) => {
  try {
    const response = await api.put(`${API_URL}/skills/${id}`, skill);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};

// Delete a skill
export const deleteSkill = async (id) => {
  try {
    const response = await api.delete(`${API_URL}/skills/${id}`);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};
